import { foundationTabsStyles } from '@genesislcap/foundation-ui';
import { neutralLayer3 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { ColorHEX } from '../_common';
export const zeroTabsStyles = (context, definition) => css `
  ${foundationTabsStyles(context, definition)}
  :host .tablist {
    padding: 0;
    display: block;
    background-color: ${neutralLayer3};
    width: 100%;
    height: 42px;
    border-bottom: calc(var(--stroke-width) * 1px) solid ${ColorHEX.lightGrey};
  }

  :host .tabpanel {
    background-color: var(--zero-card-fill-color);
  }

  :host .end,
  :host .start {
    padding: 0 30px 0 16px;
    height: calc(100% - 1px);
    display: flex;
    align-items: center;
    border-bottom: calc(var(--stroke-width) * 1px) solid ${ColorHEX.lightGrey};
    background-color: var(--neutral-layer-3);
  }

  :host([appearance='secondary']) .tablist {
    display: grid;
    grid-template-columns: repeat(18, max-content);
    background-color: var(--zero-card-fill-color);
    border-left: calc(var(--stroke-width) * 1px) solid ${ColorHEX.lightGrey};
    border-right: calc(var(--stroke-width) * 1px) solid ${ColorHEX.lightGrey};
  }

  /* We don't want to show the active indicator on the tabs */
  /* stylelint-disable-next-line selector-class-pattern */
  .activeIndicator {
    display: none;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  :host([appearance='secondary']) .tablist .activeIndicator {
    border-radius: 0;
    display: block;
    height: 2px;
    margin-top: 0;
  }
`;
